import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import User from '_class/User';
import sniffer from 'sniffer';
import Moment from 'moment';
import { getActiveSchool } from 'helpers/localstorage';
import { getParameterByName } from 'helpers/url';
import { setPageTitle } from 'actions/header';
import { setCurrentSearchTerm, searchEducationGroups, searchMentorGroups, searchStaff, searchStudents, searchAssignment, searchPlans, searchGuardians, searchPosts, clearSearch } from 'actions/search';
import { Spinner, DataList } from 'UI';
import RowItem, { RowCell } from 'UI/Elements/List/RowItem';
import { Search as SearchInput } from 'UI/Inputs';
import { Tabs, Tab, translate } from '@haldor/ui';

var Search = /*#__PURE__*/function (_Component) {
  _inherits(Search, _Component);

  var _super = _createSuper(Search);

  function Search(props) {
    var _this;

    _classCallCheck(this, Search);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
      _this.props.setPageTitle(_this.props.translate('search'));
    });

    _defineProperty(_assertThisInitialized(_this), "runSearch", function (term) {
      if (term != null && term !== '') {
        var user = new User(_this.props.currentUser);

        _this.props.clearSearch();

        _this.props.setCurrentSearchTerm(term);

        _this.setState({
          term: term,
          loading: true,
          loadingEducationGroups: true,
          loadingMentorGroups: true,
          loadingStaff: true,
          loadingGuardians: true,
          loadingStudents: true,
          loadingAssignments: true,
          loadingPosts: true,
          loadingPlans: true
        });

        if (!user.isStudent()) {
          _this.props.searchEducationGroups(term).then(function () {
            _this.setState({
              loadingEducationGroups: false
            });
          });
        }

        if (!user.isStudent()) {
          _this.props.searchMentorGroups(term).then(function () {
            _this.setState({
              loadingMentorGroups: false
            });
          });
        }

        _this.props.searchStaff(term).then(function () {
          _this.setState({
            loadingStaff: false
          });
        });

        if (!user.isStudent()) {
          _this.props.searchGuardians(term).then(function () {
            _this.setState({
              loadingGuardians: false
            });
          });
        }

        if (!user.isStudent()) {
          _this.props.searchStudents(term).then(function () {
            _this.setState({
              loadingStudents: false
            });
          });
        }

        _this.props.searchAssignment(term).then(function () {
          _this.setState({
            loadingAssignments: false
          });
        });

        _this.props.searchPlans(term).then(function () {
          _this.setState({
            loadingPlans: false
          });
        });

        _this.props.searchPosts(term).then(function () {
          _this.setState({
            loadingPosts: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onSearch", function (value) {
      _this.runSearch(value.query);
    });

    _defineProperty(_assertThisInitialized(_this), "renderGroupRow", function (group) {
      return /*#__PURE__*/React.createElement(RowItem, {
        key: group.id,
        target: "/groups/".concat(group.id)
      }, /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('name')
      }, group.title));
    });

    _defineProperty(_assertThisInitialized(_this), "renderStaff", function (user) {
      var currentUser = new User(_this.props.currentUser);
      return /*#__PURE__*/React.createElement(RowItem, {
        key: user.userId,
        target: "/user/".concat(user.userId)
      }, /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('name')
      }, user.displayName), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('e-mail')
      }, user.email), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('roles')
      }, /*#__PURE__*/React.createElement("ul", {
        style: {
          listStyleType: "none"
        }
      }, user.userRoles.filter(function (role) {
        if (currentUser.isStudent()) {
          return role.indexOf('ADMIN') == -1;
        }

        return true;
      }).map(function (role) {
        return /*#__PURE__*/React.createElement("li", {
          style: {
            padding: "2px 0px"
          },
          key: 'role-row-' + user.id + "-" + role
        }, _this.props.translate(role));
      }))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderStudent", function (user) {
      return /*#__PURE__*/React.createElement(RowItem, {
        key: user.userId,
        target: "/user/".concat(user.userId, "/progress")
      }, /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('name')
      }, user.displayName), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('e-mail')
      }, user.email));
    });

    _defineProperty(_assertThisInitialized(_this), "renderGuardian", function (user) {
      return /*#__PURE__*/React.createElement(RowItem, {
        key: user.userId,
        target: "/guardian/".concat(user.userId)
      }, /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('name')
      }, user.displayName), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('students')
      }, /*#__PURE__*/React.createElement("ul", {
        style: {
          listStyleType: "none"
        }
      }, user.students.map(function (student) {
        return /*#__PURE__*/React.createElement("li", {
          style: {
            padding: "2px 0px"
          },
          key: 'student-row-' + user.id + "--" + student.userId
        }, " ", student.firstName + " " + student.lastName, " ");
      }))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderAssignment", function (assignment) {
      return /*#__PURE__*/React.createElement(RowItem, {
        key: assignment.id,
        target: "/assignment/".concat(assignment.id)
      }, /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('column-id'),
        shrink: true
      }, assignment.id), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('title')
      }, assignment.title), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('column-group')
      }, assignment.section.title), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('start'),
        shrink: true
      }, Moment(assignment.startDate).format('YYYY-MM-DD HH:mm')), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('end'),
        shrink: true
      }, Moment(assignment.dueDate).format('YYYY-MM-DD HH:mm')));
    });

    _defineProperty(_assertThisInitialized(_this), "renderPlan", function (plan) {
      return /*#__PURE__*/React.createElement(RowItem, {
        key: plan.id,
        target: "/plan/".concat(plan.id)
      }, /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('column-id'),
        shrink: true
      }, plan.id), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('title')
      }, plan.title), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('column-group'),
        shrink: true
      }, plan.section.title), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('start'),
        shrink: true
      }, Moment(plan.timeStart).format('YYYY-MM-DD HH:mm')), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('end'),
        shrink: true
      }, Moment(plan.timeEnd).format('YYYY-MM-DD HH:mm')));
    });

    _defineProperty(_assertThisInitialized(_this), "renderPost", function (post) {
      return /*#__PURE__*/React.createElement(RowItem, {
        key: post.id,
        target: "/post/".concat(post.id)
      }, /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('column-id'),
        shrink: true
      }, post.id), /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('title')
      }, post.title));
    });

    _this.location = window.location.href;
    _this.nextTerm = '';
    _this.state = {
      loading: false,
      loadingEducationGroups: false,
      loadingMentorGroups: false,
      loadingStaff: false,
      loadingStudents: false,
      loadingAssignments: false,
      loadingPlans: false,
      loadingGuardians: false,
      loadingPosts: false,
      term: null
    };
    return _this;
  }

  _createClass(Search, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var searchString = getParameterByName('q');

      if (nextProps.term != searchString) {
        this.nextTerm = searchString;
        this.runSearch(searchString);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var searchString = getParameterByName('q');

      if (getParameterByName('q') != this.props.term) {
        this.runSearch(searchString);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props, _this$props$students, _this$props$staff, _this$props$guardians;

      var translate = this.props.translate;
      var user = new User(this.props.currentUser);
      return /*#__PURE__*/React.createElement("div", {
        className: "overview"
      }, sniffer.isDevice ? /*#__PURE__*/React.createElement(SearchInput, {
        placeholder: translate('search') + '...',
        onSubmit: this.onSearch
      }) : null, /*#__PURE__*/React.createElement(Tabs, null, /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate("All"),
        route: "all"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, !user.isStudent() ? /*#__PURE__*/React.createElement(DataList, {
        title: translate('students'),
        data: this.state.loadingStudents ? [] : (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$students = _this$props.students) === null || _this$props$students === void 0 ? void 0 : _this$props$students.sort(function (a, b) {
          return a.lastName.localeCompare(b.lastName);
        }),
        renderRow: this.renderStudent,
        emptyData: this.state.loadingStudents ? function () {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
            center: true
          }));
        } : function () {
          return /*#__PURE__*/React.createElement("div", {
            className: "color--meta text--center weight--bold"
          }, translate('no-results'));
        }
      }) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement(DataList, {
        title: translate('staff'),
        data: this.state.loadingStaff ? [] : (_this$props$staff = this.props.staff) === null || _this$props$staff === void 0 ? void 0 : _this$props$staff.sort(function (a, b) {
          return a.lastName.localeCompare(b.lastName);
        }),
        renderRow: this.renderStaff,
        emptyData: this.state.loadingStaff ? function () {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
            center: true
          }));
        } : function () {
          return /*#__PURE__*/React.createElement("div", {
            className: "color--meta text--center weight--bold"
          }, translate('no-results'));
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, user.isAdministrator() || user.isMentor() ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DataList, {
        title: translate('Guardian'),
        data: this.state.loadingGuardians ? [] : (_this$props$guardians = this.props.guardians) === null || _this$props$guardians === void 0 ? void 0 : _this$props$guardians.sort(function (a, b) {
          return a.lastName.localeCompare(b.lastName);
        }),
        renderRow: this.renderGuardian,
        emptyData: this.state.loadingGuardians ? function () {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
            center: true
          }));
        } : function () {
          return /*#__PURE__*/React.createElement("div", {
            className: "color--meta text--center weight--bold"
          }, translate('no-results'), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Link, {
            to: "/guardian"
          }, translate('show-all-guardians'))));
        }
      }), this.props.guardians.length > 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          paddingTop: "7px"
        }
      }, /*#__PURE__*/React.createElement(Link, {
        to: "/guardian"
      }, translate('show-all-guardians'))) : null) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, !user.isStudent() ? /*#__PURE__*/React.createElement(DataList, {
        title: translate('EDUCATION_GROUPS'),
        data: this.state.loadingEducationGroups ? [] : this.props.educationGroups,
        renderRow: this.renderGroupRow,
        emptyData: this.state.loadingEducationGroups ? function () {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
            center: true
          }));
        } : function () {
          return /*#__PURE__*/React.createElement("div", {
            className: "color--meta text--center weight--bold"
          }, translate('no-results'));
        }
      }) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, !user.isStudent() ? /*#__PURE__*/React.createElement(DataList, {
        title: translate('mentor-header-overview'),
        data: this.state.loadingMentorGroups ? [] : this.props.mentorGroups,
        renderRow: this.renderGroupRow,
        emptyData: this.state.loadingMentorGroups ? function () {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
            center: true
          }));
        } : function () {
          return /*#__PURE__*/React.createElement("div", {
            className: "color--meta text--center weight--bold"
          }, translate('no-results'));
        }
      }) : null), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement(DataList, {
        title: translate('tasks-header-overview'),
        data: this.state.loadingAssignments ? [] : this.props.assignments,
        renderRow: this.renderAssignment,
        emptyData: this.state.loadingAssignments ? function () {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
            center: true
          }));
        } : function () {
          return /*#__PURE__*/React.createElement("div", {
            className: "color--meta text--center weight--bold"
          }, translate('no-results'));
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement(DataList, {
        title: translate('planning-header-overview'),
        data: this.state.loadingPlans ? [] : this.props.plans,
        renderRow: this.renderPlan,
        emptyData: this.state.loadingPlans ? function () {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
            center: true
          }));
        } : function () {
          return /*#__PURE__*/React.createElement("div", {
            className: "color--meta text--center weight--bold"
          }, translate('no-results'));
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement(DataList, {
        title: translate('Posts'),
        data: this.state.loadingPosts ? [] : this.props.posts,
        renderRow: this.renderPost,
        emptyData: this.state.loadingPosts ? function () {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
            center: true
          }));
        } : function () {
          return /*#__PURE__*/React.createElement("div", {
            className: "color--meta text--center weight--bold"
          }, translate('no-results'));
        }
      }))), !this.state.loadingStudents && this.props.students != null && this.props.students.length > 0 && !user.isStudent() ? /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate("students"),
        route: "students"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement(DataList, {
        title: translate('students'),
        data: this.props.students,
        renderRow: this.renderStudent,
        emptyData: function emptyData() {
          return /*#__PURE__*/React.createElement("div", {
            className: "color--meta text--center weight--bold"
          }, translate('no-results'));
        }
      }))) : null, !this.state.loadingStaff && this.props.staff != null && this.props.staff.length > 0 ? /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate("staff"),
        route: "staff"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement(DataList, {
        title: translate('staff'),
        data: this.props.staff,
        renderRow: this.renderStaff,
        emptyData: function emptyData() {
          return /*#__PURE__*/React.createElement("div", {
            className: "color--meta text--center weight--bold"
          }, translate('no-results'));
        }
      }))) : null, (user.isAdministrator() || user.isMentor()) && !this.state.loadingGuardians && this.props.guardians != null && this.props.guardians.length > 0 ? /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate("Guardian"),
        route: "guardian"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement(DataList, {
        title: translate('Guardian'),
        data: this.props.guardians,
        renderRow: this.renderGuardian,
        emptyData: function emptyData() {
          return /*#__PURE__*/React.createElement("div", {
            className: "color--meta text--center weight--bold"
          }, translate('no-results'));
        }
      }))) : null, !this.state.loadingEducationGroups && this.props.educationGroups != null && this.props.educationGroups.length > 0 && !user.isStudent() ? /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate("EDUCATION_GROUPS"),
        route: "educationgroups"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement(DataList, {
        title: translate('EDUCATION_GROUPS'),
        data: this.props.educationGroups,
        renderRow: this.renderGroupRow,
        emptyData: function emptyData() {
          return /*#__PURE__*/React.createElement("div", {
            className: "color--meta text--center weight--bold"
          }, translate('no-results'));
        }
      }))) : null, !this.state.loadingMentorGroups && this.props.mentorGroups != null && this.props.mentorGroups.length > 0 && !user.isStudent() ? /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate("mentor-header-overview"),
        route: "mentorgroups"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement(DataList, {
        title: translate('mentor-header-overview'),
        data: this.props.mentorGroups,
        renderRow: this.renderGroupRow,
        emptyData: function emptyData() {
          return /*#__PURE__*/React.createElement("div", {
            className: "color--meta text--center weight--bold"
          }, translate('no-results'));
        }
      }))) : null, !this.state.loadingAssignments && this.props.assignments != null && this.props.assignments.length > 0 ? /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate("tasks-header-overview"),
        route: "assignments"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement(DataList, {
        title: translate('tasks-header-overview'),
        data: this.props.assignments,
        renderRow: this.renderAssignment,
        emptyData: function emptyData() {
          return /*#__PURE__*/React.createElement("div", {
            className: "color--meta text--center weight--bold"
          }, translate('no-results'));
        }
      }))) : null, !this.state.loadingPlans && this.props.plans != null && this.props.plans.length > 0 ? /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate("planning"),
        route: "plans"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement(DataList, {
        title: translate('planning-header-overview'),
        data: this.props.plans,
        renderRow: this.renderPlan,
        emptyData: function emptyData() {
          return /*#__PURE__*/React.createElement("div", {
            className: "color--meta text--center weight--bold"
          }, translate('no-results'));
        }
      }))) : null, !this.state.loadingPosts && this.props.posts != null && this.props.posts.length > 0 ? /*#__PURE__*/React.createElement(Tab, {
        title: this.props.translate("Posts"),
        route: "posts"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '2rem'
        }
      }, /*#__PURE__*/React.createElement(DataList, {
        title: translate('Posts'),
        data: this.state.loadingPosts ? [] : this.props.posts,
        renderRow: this.renderPost,
        emptyData: this.state.loadingPosts ? function () {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
            center: true
          }));
        } : function () {
          return /*#__PURE__*/React.createElement("div", {
            className: "color--meta text--center weight--bold"
          }, translate('no-results'));
        }
      }))) : null));
    }
  }]);

  return Search;
}(Component);

_defineProperty(Search, "contextTypes", {
  router: PropTypes.object
});

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    term: state.Search.term,
    educationGroups: state.Search.educationGroups,
    mentorGroups: state.Search.mentorGroups,
    staff: state.Search.staff,
    students: state.Search.students,
    assignments: state.Search.assignments,
    plans: state.Search.plans,
    currentUser: state.user.currentUser,
    guardians: state.Search.guardians,
    posts: state.Search.posts
  };
}

export default connect(mapStateToProps, {
  setCurrentSearchTerm: setCurrentSearchTerm,
  searchEducationGroups: searchEducationGroups,
  searchMentorGroups: searchMentorGroups,
  searchStaff: searchStaff,
  searchStudents: searchStudents,
  setPageTitle: setPageTitle,
  searchAssignment: searchAssignment,
  searchPlans: searchPlans,
  searchGuardians: searchGuardians,
  searchPosts: searchPosts,
  clearSearch: clearSearch
})(Search);